import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { NoteRounded } from "@mui/icons-material";
import { connect } from "react-redux";
import { selectComments } from "../../redux/selectors/firebase";
import { ICommentContainer, IScriptComment } from "./CommentContainer";

interface Props
{
    comments: { [commentId: string]: ICommentContainer },
    getItemSize: (index: number) => number,
    states: string[]
    height: number
    onClick: (index: number) => void
}

const useStyles = makeStyles(theme => ({
    heatmap: {
        position: "absolute"
    }
}));

function StateCommentsHeatmap({ height, states, getItemSize, comments, onClick }: Props)
{
    const classes = useStyles();

    const getYPosition = (index: number) =>
    {
        const listHeight = states.reduce((previous, current, index) =>
        {
            return previous + getItemSize(index);
        }, 0)

        let y = 0;
        if (listHeight > 0)
        {
            y = states.slice(0, index).reduce((previous, current, index) =>
            {
                return previous + getItemSize(index);
            }, 0);

            y /= listHeight;
        }

        return y;
    }

    const getNote = (id: string, type: IScriptComment) =>
    {
        const index = states.indexOf(type.state)
        const percent = getYPosition(index);
        return <Box key={id} style={{ position: "absolute", top: `${percent * 100}%`, transform: "translateY(-50%)" }} onClick={() => { onClick(index) }}>
            <NoteRounded color={"primary"} fontSize={"small"} />
        </Box>
    }
    
    return <Box marginLeft={"5px"} marginRight={"15px"} marginTop={"2px"}>
        <Box className={classes.heatmap} width={20} height={height} sx={{ position: "relative" }} >
            {comments && Object.entries(comments).filter(
                ([, commentContainer]) =>
                {
                    return commentContainer.type.name === "script"
                        && states.includes(commentContainer.type.state)
                        && !commentContainer.deleted
                        && !commentContainer.resolved;

                }).sort(([, aComment], [, bComment]) =>
                {
                    return (aComment.type as IScriptComment).state.localeCompare((bComment.type as IScriptComment).state);
                }
                ).map(([id, commentContainer]) =>
                {
                    return getNote(id, commentContainer.type as IScriptComment);
                })}
        </Box>
    </Box >
}

const mapStateToProps = (store: never) => ({
    comments: selectComments(store)
});

export default connect(mapStateToProps, {
})(StateCommentsHeatmap);